import { Map } from 'immutable'
import { SET_PAGE_READY } from './actions'

export const initialState = Map()

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_PAGE_READY:
      return state.set('ready', action.payload)
    default:
      return state
  }
}
